var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', [_c('guide-visual', _vm._b({}, 'guide-visual', _vm.visual, false)), _c('div', {
    staticClass: "client-content-wrap"
  }, [_c('scrolldown-tail'), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("물품후원 효과")])]), _c('v-row', _vm._l(_vm.effects, function (effect, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "border-radius-16 mx-auto text-center h-100",
      attrs: {
        "color": "#ddd",
        "max-width": "282",
        "outlined": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": effect.image,
        "alt": ""
      }
    }), _c('v-card-title', {
      staticClass: "justify-center pt-lg-40"
    }, [_c('h4', {
      staticClass: "tit tit--sm primary--text"
    }, [_vm._v(" " + _vm._s(effect.title) + " ")])]), _c('v-card-text', {
      staticClass: "pb-lg-40"
    }, [_c('p', {
      staticClass: "page-text page-text--lg",
      domProps: {
        "innerHTML": _vm._s(effect.texts)
      }
    })])], 1)], 1);
  }), 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("후원가능 물품")])]), _c('goods-tabs')], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('a', {
    attrs: {
      "href": "https://secure.donus.org/withcan/pay/step1?_gl=1*1csn9b9*_ga*MTA5ODMyNDAzLjE3MjE4MTAwODU.*_ga_1KFQVNYJMP*MTc0Mjk2Mzc5OS4yMi4xLjE3NDI5NjU5ODYuNTkuMC4w",
      "target": "_blank"
    }
  }, [_c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/guide/goods/mobile-banner.jpg",
      "alt": ""
    }
  })], 1), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-card', {
    staticClass: "banner",
    attrs: {
      "tile": "",
      "flat": "",
      "img": "/images/guide/goods/banner.jpg"
    }
  }, [_c('v-container', [_c('p', {
    staticClass: "page-text page-text--lg white--text mb-12 mb-lg-16"
  }, [_vm._v("With You, With Can")]), _c('h2', {
    staticClass: "banner__title font-aggro white--text"
  }, [_c('p', [_vm._v(" 당신과 함께라면, 저소득층에게 "), _c('br'), _vm._v(" 더 많은 희망을 전할 수 있습니다. ")])]), _c('contact-dialog', {
    attrs: {
      "business": "물품후원"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          staticClass: "mt-20 mt-md-40",
          attrs: {
            "color": "white",
            "large": "",
            "rounded": "pill"
          }
        }, 'v-btn', attrs, false), on), [_c('span', {
          staticClass: "font-size-18 font-size-md-20 font-aggro mb-n4 primary--text w-lg-160px text-center"
        }, [_vm._v("후원하기")]), _c('v-icon', {
          staticClass: "ml-10",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chevron-right")])], 1)];
      }
    }])
  })], 1)], 1)], 1)]), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("물품후원 안내")])]), _c('v-img', {
    staticClass: "d-md-none",
    attrs: {
      "src": "/images/guide/goods/process-list.png",
      "alt": ""
    }
  }), _c('div', {
    staticClass: "d-none d-md-block"
  }, [_c('v-row', {
    staticClass: "process-list row--lg"
  }, _vm._l(_vm.process, function (item, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('v-card', {
      staticClass: "process-card",
      attrs: {
        "color": "#FAFAFA",
        "flat": ""
      }
    }, [_c('v-row', {
      staticClass: "text-center"
    }, [_c('v-col', {
      attrs: {
        "cols": "12"
      }
    }, [_c('div', {
      staticClass: "primary--text font-weight-bold font-size-28"
    }, [_vm._v("0" + _vm._s(index + 1))]), _c('div', {
      staticClass: "client-title--xs font-weight-bold my-24",
      domProps: {
        "innerHTML": _vm._s(item.name)
      }
    }), _c('p', {
      staticClass: "page-text page-text--lg",
      domProps: {
        "innerHTML": _vm._s(item.text)
      }
    }), _c('v-img', {
      staticClass: "mt-28 mx-auto",
      attrs: {
        "src": `/images/guide/goods/progress-${index + 1}.svg`,
        "max-width": "60"
      }
    })], 1)], 1)], 1)], 1);
  }), 1)], 1), _c('div', {
    staticClass: "text-center mt-40 mt-lg-80"
  }, [_c('contact-dialog', {
    attrs: {
      "business": "물품후원"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref2) {
        var on = _ref2.on,
          attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "large": "",
            "color": "primary",
            "rounded": "pill"
          }
        }, 'v-btn', attrs, false), on), [_vm._v(" 물품후원 신청하기 "), _c('v-icon', {
          staticClass: "ml-10",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-chevron-right")])], 1)];
      }
    }])
  })], 1)], 1)], 1), _c('section', {
    staticClass: "client-section"
  }, [_c('v-container', [_c('div', {
    staticClass: "section-title-wrap"
  }, [_c('h2', {
    staticClass: "section-title"
  }, [_vm._v("자주 묻는 질문")])]), _c('faq-list', {
    attrs: {
      "items": _vm.faq
    }
  })], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }